import { Component, Input, OnInit } from "@angular/core";
import printJS from "print-js";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "release-notes-list",
  templateUrl: "./release-notes-list.component.html",
})
export class ReleaseNotesListComponent implements OnInit {

  @Input() public releases: any[] = [];
  public externals: any[] = [];
  public availableTypes: any[] = [];
  @Input() public service: any;

  public expended: boolean = false;
  public liveFilter: boolean = true;
  public today = new Date();

  public showFilters: boolean = false;

  constructor(public translate: TranslateService,
  ) { }

  public ngOnInit(): void {
    if (this.releases && this.releases.length) {
      this.releases = this.releases.filter((h) => {
        return h.title !== null && h.typesOfPublication.length;
      });
      this.initExternals();
      this.initTypes();
    }
  }

  public initTypes() {
    this.releases.forEach((r) => {
      r.typesOfPublication.forEach((t) => {
        if (!this.availableTypes.some((e) => e.type === t)) {
          this.availableTypes.push({
            type: t,
            status: true,
          });
        }
      });
    });
  }

  public initExternals() {
    this.releases.forEach((r) => {
      if (r.destination && !this.externals.some((e) => e.type === r.destination)) {
        this.externals.push({
          type: r.destination,
          status: true,
        });
      }
    });
  }

  public filtered(rc) {
    let hasExt = false;
    let hasLive = false;
    let hasType = false;
    if (rc.destination && this.externals.some((e) => e.type === rc.destination && e.status)) {
      hasExt = true;
    }
    if (!rc.destination && this.liveFilter) {
      hasLive = true;
    }
    hasType = rc.typesOfPublication.some((t) => {
      return this.availableTypes.some((a) => {
        return a.type === t && a.status;
      });
    });
    return !((hasExt || hasLive) && hasType);
  }

  public toggleAll() {
    this.expended = !this.expended;
    this.releases.forEach((r) => {
      r.open = this.expended;
    });
  }

  public toggleRc(rc) {
    rc.open = !rc.open;
    const opened = this.releases.filter((r) => {
      return r.open;
    }).length;
    const closed = this.releases.filter((r) => {
      return !r.open;
    }).length;
    if (opened === this.releases.length) {
      this.expended = true;
    }
    if (closed === this.releases.length) {
      this.expended = false;
    }
  }

  public printRN() {
    printJS({
      printable: document.getElementById("release-notes-list").innerHTML,
      type: "raw-html",
      showModal: true,
      // header: `<div style="text-align: end; width: 100%">${this.service?.name} - ${this.translate.instant("Release notes")}</span>`,
      documentTitle: `${this.service?.name} - ${this.translate.instant("Release notes")}`,
      css: "/assets/styles/print-release-notes.css",
    });
  }

}
